import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { resolveLabel } from '@/lib/fieldLabel';

export function StatsDialog({ open, onOpenChange, result, queryExplanation, allFields }) {
  const _fields = allFields || [];
  const _resolveMeasure = (m) => {
    if (typeof m !== 'string') return m;
    const mm = m.match(/^([A-Za-z0-9_]+)\((.*)\)$/);
    return mm ? `${mm[1]}(${resolveLabel(_fields, mm[2])})` : resolveLabel(_fields, m);
  };
  const dimLabels = (queryExplanation?.dimensions || []).map((d) => resolveLabel(_fields, d));
  const measureLabels = (queryExplanation?.measures || []).map(_resolveMeasure);
  const summaryText = (queryExplanation && (queryExplanation.dimensions || queryExplanation.measures))
    ? `Query groups by ${dimLabels.join(', ') || 'none'} and aggregates ${measureLabels.join(', ') || 'none'}`
    : queryExplanation?.summary;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-card border-border/50 rounded-2xl sm:max-w-2xl max-h-[80vh] overflow-auto">
        <DialogHeader><DialogTitle className="font-heading">Report Statistics & Query</DialogTitle></DialogHeader>
        <div className="space-y-4 mt-2">
          {result && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              <div className="p-3 rounded-xl bg-muted/20 border border-border/30 text-center min-w-0"><p className="text-lg font-heading font-bold text-foreground truncate">{result.row_count}</p><p className="text-[9px] text-muted-foreground">Rows Returned</p></div>
              <div className="p-3 rounded-xl bg-muted/20 border border-border/30 text-center min-w-0"><p className="text-lg font-heading font-bold text-foreground truncate">{result.duration_ms}ms</p><p className="text-[9px] text-muted-foreground">Execution Time</p></div>
              <div className="p-3 rounded-xl bg-muted/20 border border-border/30 text-center min-w-0"><p className="text-lg font-heading font-bold text-foreground truncate">{result.from_cache ? 'Yes' : 'No'}</p><p className="text-[9px] text-muted-foreground">From Cache</p></div>
              <div className="p-3 rounded-xl bg-muted/20 border border-border/30 text-center min-w-0"><p className="text-sm font-heading font-bold text-foreground break-words leading-tight" title={result.collection || '-'}>{result.collection || '-'}</p><p className="text-[9px] text-muted-foreground mt-0.5">Collection</p></div>
            </div>
          )}
          {queryExplanation && (
            <div className="space-y-3">
              <div className="p-3 rounded-xl bg-primary/5 border border-primary/10"><p className="text-xs text-foreground">{summaryText}</p></div>
              <div className="grid grid-cols-2 gap-3 text-xs">
                <div><span className="text-muted-foreground">Dimensions:</span> <span className="text-foreground">{dimLabels.join(', ') || 'none'}</span></div>
                <div><span className="text-muted-foreground">Measures:</span> <span className="text-foreground">{measureLabels.join(', ') || 'none'}</span></div>
                <div><span className="text-muted-foreground">Filters:</span> <span className="font-mono text-foreground">{(queryExplanation.filters || []).join(', ') || 'none'}</span></div>
                <div><span className="text-muted-foreground">Stages:</span> <span className="font-mono text-foreground">{queryExplanation.pipeline_stages}</span></div>
              </div>
              <div>
                <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">MongoDB Aggregation Pipeline</p>
                <pre className="p-3 rounded-xl bg-background border border-border/30 text-[10px] font-mono text-foreground/80 overflow-auto max-h-64 whitespace-pre-wrap">{JSON.stringify(queryExplanation.pipeline, null, 2)}</pre>
              </div>
            </div>
          )}
          {!result && <p className="text-xs text-muted-foreground text-center py-4">Execute a query first to see statistics</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
